import {
  customReservedInventoryBucketTypeIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const bulkUpdateReservedInventoryBuckets = {
  name: "bulkUpdateReservedInventoryBuckets" as const,
  input: z.object({
    productIds: z.array(productIdFormat.schema).min(1).max(10_000),
    locationId: locationIdFormat.schema,
    kind: z.string().nullable(),
    customTypeId: customReservedInventoryBucketTypeIdFormat.schema
      .nullable()
      .optional(),
    value: z.union([
      z.object({ quantity: z.number().int().min(0) }),
      z.object({ onHandPercentage: z.number().min(0).max(100) }),
    ]),
  }),
  output: z.object({ success: z.boolean() }),
};
